import React from "react";

export const highlightText = (text: string, search: string): (string | JSX.Element)[]=> {
  if (!search) return [text];

  // 转义正则表达式特殊字符
  const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${escapedSearch})`, "gi"));

  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? <span key={i} className="dba-text-highlight">{part}</span> : part
  );
};